// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__kKoEQ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__CPJaV"};